/**
 * Recently viewed products — localStorage, max 12.
 */

const STORAGE_KEY = 'dc_recently_viewed';
const MAX_ITEMS = 12;

function read() {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		const parsed = raw ? JSON.parse(raw) : [];
		return Array.isArray(parsed) ? parsed.map(Number).filter(Boolean) : [];
	} catch {
		return [];
	}
}

function write(ids) {
	localStorage.setItem(STORAGE_KEY, JSON.stringify(ids.slice(0, MAX_ITEMS)));
}

function trackCurrentProduct() {
	if (!document.body.classList.contains('single-product')) {
		return;
	}

	const productEl = document.querySelector('.single-product .product');
	const match = productEl?.className.match(/\bpost-(\d+)\b/);
	const productId = match ? Number(match[1]) : 0;

	if (!productId) {
		return;
	}

	const ids = read().filter((id) => id !== productId);
	ids.unshift(productId);
	write(ids);
}

export function initRecentlyViewed() {
	trackCurrentProduct();
}

export { read as getRecentlyViewed };
